import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { styles as buttonStyles } from '~/components/Button';
import { styles as textStyles } from '~/components/Text';
import { replaceClassNames } from '~/utils/converters';
import styles from './Hero.module.scss';

interface HeroItem {
    id: string;
    html: string;
    image: string | null;
    imageMobile: string | null;
    content: string | null;
    actions: string[];
    action: string[];
}

interface HeroProps {
    sliderItems: HeroItem[];
}

const Hero: FC<HeroProps> = ({ sliderItems }) => {

    return sliderItems?.length > 0 && (
        <section className={styles.hero}>
            <Swiper
                {...{
                    autoplay: true,
                    infinite: sliderItems?.length > 1 ? 'true' : 'false'
                }}
            >
                {sliderItems?.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className={styles.hero_item}
                            dangerouslySetInnerHTML={{
                                __html: replaceClassNames(item.html, {
                                    Hero: styles,
                                    Button: buttonStyles,
                                    Text: textStyles
                                })
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default Hero;
